export default __webpack_public_path__ + "static/media/mculelogo.8c64c9ec.png";